<template>
  <div class="skeleton rounded" :class="bgClass">
    <div class="shimmer" :style="shimmerStyle"></div>
  </div>
</template>

<script>
export default {
  props: {
    bgClass: { type: String, default: 'bg-light' },
    shineColor: { type: String, default: 'var(--white)' }
  },
  computed: {
    shimmerStyle () {
      return 'background-image: linear-gradient(90deg, rgba(255,255,255,0) 0px, ' + this.shineColor + ' 40px, rgba(255,255,255,0) 80px);'
    }
  }
}
</script>

<style scoped>
.skeleton {
  background-color: #F7F8F9;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 2em;
  min-width: 2em;
  position: relative;
}

.shimmer {
  background-size: 80px 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  animation: shine-lines 2s infinite ease-in-out;
}

@keyframes shine-lines {
  0% {
    left: -80px;
  }
  100% {
    left: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/SkeletonRectangle.vue